import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function CameraIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.1372 2.75445H18.1332C17.8998 2.75445 17.6771 2.66079 17.5155 2.49488L15.8264 0.761937C15.4738 0.402782 14.9931 0.200195 14.4922 0.200195H9.5082C9.00615 0.200195 8.52505 0.40293 8.17457 0.761378L6.48503 2.49476C6.32281 2.66064 6.0998 2.75445 5.8672 2.75445H1.8632C0.834056 2.75445 0.000198364 3.58774 0.000198364 4.61618V15.9375C0.000198364 16.966 0.834133 17.8002 1.8632 17.8002H22.1372C23.1656 17.8002 24.0002 16.9657 24.0002 15.9375V4.61618C24.0002 3.58803 23.1656 2.75445 22.1372 2.75445ZM22.1372 3.75377C22.6135 3.75377 23.0002 4.14005 23.0002 4.61618V15.9375C23.0002 16.4139 22.6132 16.8009 22.1372 16.8009H1.8632C1.38664 16.8009 1.0002 16.4143 1.0002 15.9375V4.61618C1.0002 4.13965 1.38634 3.75377 1.8632 3.75377H5.8672C6.369 3.75377 6.84986 3.5515 7.20081 3.19261L8.89037 1.45921C9.05229 1.29361 9.27559 1.19951 9.5082 1.19951H14.4922C14.724 1.19951 14.9476 1.29376 15.1113 1.46047L16.799 3.19203C17.149 3.55135 17.6302 3.75377 18.1332 3.75377H22.1372ZM12 4.03098C14.746 4.03098 16.972 6.25617 16.972 9.0006C16.972 11.7442 14.7458 13.9692 12 13.9692C9.25418 13.9692 7.028 11.7442 7.028 9.0006C7.028 6.25617 9.25401 4.03098 12 4.03098ZM12 5.0303C9.80637 5.0303 8.028 6.80801 8.028 9.0006C8.028 11.1923 9.8065 12.9699 12 12.9699C14.1935 12.9699 15.972 11.1923 15.972 9.0006C15.972 6.80801 14.1936 5.0303 12 5.0303Z'
      />
    </svg>
  );
}
